import type { IMessageElement } from '@chainlit/react-client';

import { ElementRef } from '@/components/Elements/ElementRef';
import { getCitationSideElements } from '@/lib/message';

interface Props {
  elements: IMessageElement[];
  messageId: string;
  messageContent?: string;
}

const persistedSourceFallback = (content?: string): string | undefined => {
  const values = (content || '')
    .split('\n')
    .map((line) => line.trim().replace(/^[-*_\s]+/, ''))
    .filter((line) => /^(?:sources?|izvori?)\s*:/i.test(line))
    .map((line) => {
      const value = line.slice(line.indexOf(':') + 1);
      return value
        .replace(/^[-*_:\s]+/, '')
        .replace(/[*_\s]+$/, '')
        .trim();
    })
    .filter(Boolean);

  return values.length ? values.join('\n') : undefined;
};

const CitationChips = ({ elements, messageId, messageContent }: Props) => {
  const citationElements = getCitationSideElements(elements, messageId);
  const fallback = persistedSourceFallback(messageContent);

  if (!citationElements.length) {
    return null;
  }

  return (
    <div className="flex flex-wrap gap-1.5">
      {citationElements.map((element) => (
        <ElementRef
          key={element.id ?? element.name}
          element={
            fallback && (!element.url || element.url.includes('/project/file/'))
              ? {
                  ...element,
                  url: `data:text/plain;charset=utf-8,${encodeURIComponent(fallback)}`
                }
              : element
          }
        />
      ))}
    </div>
  );
};

export { CitationChips };
